import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { RESIDENTIAL, TIERS, COMMERCIAL, revealUp } from "../../lib/mrs";

export const Pricing = () => {
  return (
    <section
      id="packages"
      data-testid="packages-section"
      className="relative bg-[#121412] py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-20 border-y border-[#eae7e0]/10"
    >
      <div className="max-w-2xl mb-14 md:mb-20">
        <motion.p
          variants={revealUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-[11px] md:text-sm tracking-[0.28em] uppercase text-[#b89b72] mb-5"
        >
          Choose Your Scope
        </motion.p>
        <motion.h2
          variants={revealUp}
          custom={1}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="font-display font-light text-[#eae7e0] leading-[1.05] text-4xl md:text-5xl lg:text-6xl tracking-tight"
        >
          Interior packages, built around you.
        </motion.h2>
      </div>

      {/* Residential tiers */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 mb-8">
        {TIERS.map((tier, ti) => (
          <motion.div
            key={tier.key}
            variants={revealUp}
            custom={ti}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            data-testid={`pricing-tier-${tier.key}`}
            className={`relative flex flex-col p-8 md:p-10 border transition-colors duration-500 ${
              tier.featured
                ? "bg-[#0a0b0a] border-[#b89b72]/50"
                : "bg-[#0a0b0a] border-[#eae7e0]/10 hover:border-[#eae7e0]/25"
            }`}
          >
            {tier.featured && (
              <span className="absolute top-0 right-0 bg-[#b89b72] text-[#0a0b0a] text-[10px] tracking-[0.2em] uppercase px-4 py-1.5">
                Most Chosen
              </span>
            )}
            <h3 className="font-display text-3xl md:text-4xl font-normal text-[#eae7e0] mb-2">
              {tier.name}
            </h3>
            <p className="text-sm text-[#9ca399] leading-relaxed mb-8 min-h-[60px]">
              {tier.note}
            </p>

            <div className="mt-auto space-y-3 border-t border-[#eae7e0]/10 pt-6">
              {RESIDENTIAL.map((r) => (
                <div
                  key={r.bhk}
                  className="flex items-center justify-between text-sm md:text-base"
                >
                  <span className="text-[#9ca399]">{r.bhk}</span>
                  <span className="font-num text-lg md:text-xl text-[#eae7e0]">
                    ₹ {r[tier.key]}
                  </span>
                </div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>

      {/* Commercial callout */}
      <motion.div
        variants={revealUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        data-testid="pricing-commercial"
        className="bg-[#0a0b0a] border border-[#eae7e0]/10 p-8 md:p-10"
      >
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <p className="text-[11px] tracking-[0.24em] uppercase text-[#b89b72] mb-2">
              Commercial Interiors
            </p>
            <h3 className="font-display text-2xl md:text-3xl text-[#eae7e0]">
              Priced per square foot
            </h3>
          </div>
          <div className="grid grid-cols-3 gap-6 md:gap-12">
            {COMMERCIAL.map((c) => (
              <div key={c.tier}>
                <p className="text-xs tracking-wide uppercase text-[#9ca399] mb-1">
                  {c.tier}
                </p>
                <p className="font-num text-xl md:text-2xl text-[#eae7e0]">
                  ₹ {c.rate}
                  <span className="text-sm text-[#9ca399]"> /sqft</span>
                </p>
              </div>
            ))}
          </div>
        </div>
      </motion.div>

      <p className="mt-8 flex items-center gap-2 text-xs md:text-sm text-[#9ca399]/70">
        <Check size={14} className="text-[#b89b72]" />
        Statutory charges & taxes not included. Subject to site conditions,
        contact us for a detailed custom quote.
      </p>
    </section>
  );
};
